exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.cv-tab button {\r\n  width: 100%;\r\n}\r\n\r\n#button-div {\r\n  max-width: 25%;\r\n  width: 100%;\r\n}\r\n\r\n@media (max-width: 991px) {\r\n  #button-div {\r\n    max-width: 20%;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px), (min-width: 992px) and (max-width: 1199px) {\r\n  #button-div {\r\n    max-width: 33.33334%;\r\n  }\r\n}\r\n\r\n@media (max-width: 460px) {\r\n  #button-div {\r\n    max-width: 50%;\r\n  }\r\n}\r\n\r\n@media (max-width: 344px) {\r\n  #button-div {\r\n    max-width: 100%;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/cvs/cvs.component.css
// module id = ../../../../../src/app/cvs/cvs.component.css
// module chunks = main